import AdminDashboard              from './AdminDashboard';
import PlayerDashboard             from './PlayerDashboard';
import CoachDashboard              from './CoachDashboard';
import EntityPlatformAdminDashboard from './entityPlatformAdminDashboard/EntityPlatformAdminDashboard';
// import PresidentDashboard        from './PresidentDashboard';
// import DirecteurDashboard        from './DirecteurDashboard';
// import ManagerDashboard          from './ManagerDashboard';
// import MedicalStaffDashboard     from './MedicalStaffDashboard';
// import DirectionStaffDashboard   from './DirectionStaffDashboard';
import Event from './events/pages/Event'

// ── Add new roles here as you build their dashboards ──────────────────────
const ROLE_MAP = {
  admin:               AdminDashboard,
  entityPlatformAdmin: EntityPlatformAdminDashboard,  // now has its own dashboard
  player:              PlayerDashboard,
  coach:               CoachDashboard,
  event:               Event,
  // president:          PresidentDashboard,
  // directeur:          DirecteurDashboard,
  // manager:            ManagerDashboard,
  // medical_staff:      MedicalStaffDashboard,
  // direction_statff:   DirectionStaffDashboard, // note: matches the typo in your role list
};

const DashboardRouter = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role || 'player';
  const Dashboard = ROLE_MAP[role] || PlayerDashboard;
  return <Dashboard user={user} />;
};

export default DashboardRouter;